
define('template!webshopFiltersListView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (filters.length === 0) { ;
__p += '\n<div class="empty">' +
((__t = ( _.i18n('webshop.filters.none', null, 'No filter') )) == null ? '' : __t) +
'</div>\n';
 } ;
__p += '\n';
 _.each(filters, function (f) { ;
__p += '\n<div class="filter ';
 if (f.id === selectedId) { ;
__p += 'selected';
 } ;
__p += '" data-id="' +
((__t = ( f.id )) == null ? '' : __t) +
'">\n    <div class="line">\n        <span class="name">' +
__e( f.name ) +
'</span>\n        <span class="origin ' +
((__t = ( f.webshop ? 'webshop' : 'pim' )) == null ? '' : __t) +
'">' +
((__t = ( f.webshop ? 'Webshop' : 'PIM' )) == null ? '' : __t) +
'</span>\n    </div>\n    <div class="line infos">\n        <span class="code">' +
__e( f.code ) +
'</span>\n        <span class="counts">' +
((__t = ( f.valueCount )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('webshop.filters.values', null, 'values') )) == null ? '' : __t) +
' · ' +
((__t = ( f.productCount )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('common.products', null, 'products') )) == null ? '' : __t) +
'</span>\n    </div>\n</div>\n';
 }); ;
__p += '\n';

}
return __p
};});

